// import React, { useState } from 'react';
// import { 
//   Container, 
//   Box, 
//   Typography, 
//   Grid, 
//   Link, 
//   IconButton, 
//   useTheme,
//   alpha,
//   Chip,
//   Tooltip
// } from '@mui/material';
// import { 
//   Facebook, 
//   Twitter, 
//   Instagram, 
//   LinkedIn,
//   Email,
//   Phone,
//   LocationOn,
//   School,
//   AutoAwesome,
//   TrendingUp,
//   SupportAgent
// } from '@mui/icons-material';
// import { motion } from 'framer-motion';
// import { styled, keyframes } from '@mui/material/styles';

// // Animations
// const float = keyframes`
//   0%, 100% { transform: translateY(0px); }
//   50% { transform: translateY(-5px); }
// `;

// const shimmer = keyframes`
//   0% { background-position: -200% 0; }
//   100% { background-position: 200% 0; }
// `;

// const pulse = keyframes`
//   0%, 100% { transform: scale(1); }
//   50% { transform: scale(1.05); }
// `;


// // Styled Components
// const FooterContainer = styled(Box)(({ theme }) => ({
//   background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)',
//   color: '#f8fafc',
//   position: 'relative',
//   overflow: 'hidden',
//   '&::before': {
//     content: '""',
//     position: 'absolute',
//     top: 0,
//     left: 0,
//     right: 0,
//     height: '1px',
//     background: 'linear-gradient(90deg, transparent, rgba(102, 126, 234, 0.5), transparent)',
//   },
//   '&::after': {
//     content: '""',
//     position: 'absolute',
//     top: 0,
//     left: 0,
//     right: 0,
//     bottom: 0,
//     background: 'url("data:image/svg+xml,%3Csvg width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg"%3E%3Cg fill="none" fill-rule="evenodd"%3E%3Cg fill="%23ffffff" fill-opacity="0.02"%3E%3Ccircle cx="30" cy="30" r="1"/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")',
//     animation: `${float} 20s ease-in-out infinite`,
//   }
// }));

// const LogoContainer = styled(Box)({
//   display: 'flex',
//   alignItems: 'center',
//   textDecoration: 'none',
//   transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
//   '&:hover': {
//     transform: 'scale(1.05) translateY(-2px)',
//   }
// });

// const LogoImage = styled('img')({
//   height: 60,
//   marginRight: 16,
//   transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
//   filter: 'drop-shadow(0 4px 8px rgba(102, 126, 234, 0.3))',
//   '&:hover': {
//     transform: 'rotate(-5deg) scale(1.1)',
//     filter: 'drop-shadow(0 6px 12px rgba(102, 126, 234, 0.4))',
//   }
// });

// const LogoText = styled(Typography)({
//   fontFamily: '"Inter", "Montserrat", sans-serif',
//   fontWeight: 800,
//   fontSize: '1.8rem',
//   background: 'linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%)',
//   WebkitBackgroundClip: 'text',
//   WebkitTextFillColor: 'transparent',
//   backgroundSize: '200% 200%',
//   animation: `${shimmer} 3s ease-in-out infinite`,
//   textTransform: 'uppercase',
//   letterSpacing: '0.5px',
// });

// const SectionTitle = styled(Typography)({
//   fontWeight: 700,
//   fontSize: '1.2rem',
//   marginBottom: 24,
//   position: 'relative',
//   display: 'inline-block',
//   '&::after': {
//     content: '""',
//     position: 'absolute',
//     bottom: -8,
//     left: 0,
//     width: '50%',
//     height: '3px',
//     background: 'linear-gradient(90deg, #667eea 0%, #764ba2 100%)',
//     borderRadius: '2px',
//   }
// });

// const FooterLink = styled(Link)(({ theme }) => ({
//   color: '#cbd5e0',
//   textDecoration: 'none',
//   display: 'flex',
//   alignItems: 'center',
//   padding: '8px 0',
//   transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
//   position: 'relative',
//   '&:hover': {
//     color: '#667eea',
//     transform: 'translateX(8px)',
//     '&::before': {
//       content: '""',
//       position: 'absolute',
//       left: -16,
//       top: '50%',
//       transform: 'translateY(-50%)',
//       width: 4,
//       height: 4,
//       borderRadius: '50%',
//       background: '#667eea',
//       animation: `${pulse} 1s ease-in-out infinite`,
//     }
//   }
// }));

// const SocialIconButton = styled(IconButton)(({ color }) => ({
//   color: '#cbd5e0',
//   transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
//   borderRadius: '12px',
//   padding: '12px',
//   '&:hover': {
//     color: color || '#667eea',
//     backgroundColor: alpha(color || '#667eea', 0.1),
//     transform: 'translateY(-3px) scale(1.1)',
//     boxShadow: `0 8px 25px ${alpha(color || '#667eea', 0.3)}`,
//   }
// }));

// const ContactItem = styled(Box)({
//   display: 'flex',
//   alignItems: 'center',
//   marginBottom: 16,
//   padding: '8px 0',
//   transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
//   '&:hover': {
//     transform: 'translateX(8px)',
//   }
// });

// const StatsCard = styled(Box)(({ theme }) => ({
//   background: 'rgba(255, 255, 255, 0.05)',
//   backdropFilter: 'blur(10px)',
//   borderRadius: '16px',
//   padding: theme.spacing(3),
//   border: '1px solid rgba(255, 255, 255, 0.1)',
//   textAlign: 'center',
//   transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
//   '&:hover': {
//     transform: 'translateY(-5px)',
//     background: 'rgba(255, 255, 255, 0.08)',
//     boxShadow: '0 10px 30px rgba(0, 0, 0, 0.2)',
//   }
// }));

// const FooterBottom = styled(Box)({
//   borderTop: '1px solid rgba(255, 255, 255, 0.1)',
//   paddingTop: 24,
//   marginTop: 40,
//   textAlign: 'center',
//   position: 'relative',
//   '&::before': {
//     content: '""',
//     position: 'absolute',
//     top: 0,
//     left: '50%',
//     transform: 'translateX(-50%)',
//     width: '60px',
//     height: '3px',
//     background: 'linear-gradient(90deg, #667eea 0%, #764ba2 100%)',
//     borderRadius: '2px',
//   }
// });

// const Footer = () => {
//   const theme = useTheme();
//   const [hoveredIcon, setHoveredIcon] = useState(null);
//   const socialLinks = [
//     { icon: <Facebook />, href: '#', color: '#1877f2', label: 'Facebook' },
//     { icon: <Twitter />, href: '#', color: '#1da1f2', label: 'Twitter' },
//     { icon: <Instagram />, href: '#', color: '#e4405f', label: 'Instagram' },
//     { icon: <LinkedIn />, href: '#', color: '#0077b5', label: 'LinkedIn' },
//   ];

//   const quickLinks = [
//     { label: 'Home', href: '/' },
//     { label: 'About', href: '/about' },
//     { label: 'Dashboard', href: '/dashboard' },
//     { label: 'Contact', href: '/contact' },
//   ];

//   const resources = [
//     { label: 'Syllabus & Papers', href: '/documents' },
//     { label: 'Notices', href: '/notices' },
//     { label: 'Calendar', href: '/calendar' },
//     { label: 'Help Center', href: '/help' },
//   ];

//   const contactInfo = [
//     { icon: <Email />, text: 'info@examace.com', href: 'mailto:info@examace.com' },
//     { icon: <Phone />, text: '+1 (555) 123-4567', href: 'tel:+15551234567' },
//     { icon: <LocationOn />, text: '123 Education St, Learning City', href: '#' },
//   ];

//   const stats = [
//     { number: '10K+', label: 'Students', icon: <School /> },
//     { number: '95%', label: 'Success Rate', icon: <TrendingUp /> },
//     { number: '24/7', label: 'Support', icon: <SupportAgent /> },
//   ];

//   return (
//     <FooterContainer>
//       <Box sx={{ 
//         position: 'relative', 
//         zIndex: 1, 
//         py: 8,
//         maxWidth: '1200px',
//         margin: '0 auto',
//         width: '100%',
//         px: 2
//       }}>
//         {/* Main Footer Content */}
//         <Grid container spacing={6}>
//           {/* Brand Section */}
//           <Grid item xs={12} md={4}>
//             <motion.div
//               initial={{ opacity: 0, y: 30 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.6 }}
//               viewport={{ once: true }}
//             >
//               <LogoContainer>
//                 <LogoImage src="/exam.png" alt="SSPACE Assist Logo" />
//                 <LogoText variant="h4">
//                   SSPACE Assist
//                 </LogoText>
//               </LogoContainer>
              
//               <Typography variant="body1" sx={{ 
//                 color: '#cbd5e0', 
//                 mb: 3, 
//                 lineHeight: 1.6,
//                 fontSize: '1.1rem'
//               }}>
//                 Your comprehensive platform for academic excellence and management. 
//                 Empowering students and educators with cutting-edge tools.
//               </Typography>

//               {/* Contact Info */}
//               <Box sx={{ mb: 4 }}>
//                 {contactInfo.map((contact, index) => (
//                   <ContactItem key={index}>
//                     <Box sx={{ 
//                       color: '#667eea', 
//                       mr: 2, 
//                       display: 'flex', 
//                       alignItems: 'center' 
//                     }}>
//                       {contact.icon}
//                     </Box>
//                     <FooterLink href={contact.href} color="inherit">
//                       {contact.text}
//                     </FooterLink>
//                   </ContactItem>
//                 ))}
//               </Box>

//               {/* Social Links */}
//               <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
//                 {socialLinks.map((social, index) => (
//                   <Tooltip key={index} title={social.label} arrow>
//                     <SocialIconButton
//                       href={social.href}
//                       color={social.color}
//                       onMouseEnter={() => setHoveredIcon(index)}
//                       onMouseLeave={() => setHoveredIcon(null)}
//                     >
//                       {social.icon}
//                     </SocialIconButton>
//                   </Tooltip>
//                 ))}
//               </Box>
//             </motion.div>
//           </Grid>

//           {/* Quick Links Section */}
//           <Grid item xs={12} sm={6} md={2}>
//             <motion.div
//               initial={{ opacity: 0, y: 30 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.6, delay: 0.1 }}
//               viewport={{ once: true }}
//             >
//               <SectionTitle variant="h6">
//                 Quick Links
//               </SectionTitle>
//               <Box component="ul" sx={{ listStyle: 'none', padding: 0, margin: 0 }}>
//                 {quickLinks.map((link, index) => (
//                   <Box component="li" key={index}>
//                     <FooterLink href={link.href} color="inherit">
//                       {link.label}
//                     </FooterLink>
//                   </Box>
//                 ))}
//               </Box>
//             </motion.div>
//           </Grid>

//           {/* Resources Section */}
//           <Grid item xs={12} sm={6} md={2}>
//             <motion.div
//               initial={{ opacity: 0, y: 30 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.6, delay: 0.2 }}
//               viewport={{ once: true }}
//             >
//               <SectionTitle variant="h6">
//                 Resources
//               </SectionTitle>
//               <Box component="ul" sx={{ listStyle: 'none', padding: 0, margin: 0 }}>
//                 {resources.map((resource, index) => (
//                   <Box component="li" key={index}>
//                     <FooterLink href={resource.href} color="inherit">
//                       {resource.label}
//                     </FooterLink>
//                   </Box>
//                 ))}
//               </Box>
//             </motion.div>
//           </Grid>

//           {/* Stats Section */}
//           <Grid item xs={12} md={4}>
//             <motion.div
//               initial={{ opacity: 0, y: 30 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.6, delay: 0.3 }}
//               viewport={{ once: true }}
//             >
//               <SectionTitle variant="h6">
//                 Our Impact
//               </SectionTitle>
//               <Grid container spacing={2}>
//                 {stats.map((stat, index) => (
//                   <Grid item xs={4} key={index}>
//                     <StatsCard>
//                       <Box sx={{ 
//                         color: '#667eea', 
//                         mb: 1,
//                         display: 'flex',
//                         justifyContent: 'center'
//                       }}>
//                         {stat.icon}
//                       </Box>
//                       <Typography variant="h6" sx={{ 
//                         fontWeight: 'bold', 
//                         color: '#f8fafc',
//                         fontSize: '1.2rem'
//                       }}>
//                         {stat.number}
//                       </Typography>
//                       <Typography variant="body2" sx={{ 
//                         color: '#cbd5e0',
//                         fontSize: '0.8rem'
//                       }}>
//                         {stat.label}
//                       </Typography>
//                     </StatsCard>
//                   </Grid>
//                 ))}
//               </Grid>
//             </motion.div>
//           </Grid>
//         </Grid>

//         {/* Newsletter Section */}
//         <motion.div
//           initial={{ opacity: 0, y: 30 }}
//           whileInView={{ opacity: 1, y: 0 }}
//           transition={{ duration: 0.6, delay: 0.4 }}
//           viewport={{ once: true }}
//         >
//           <Box sx={{ 
//             mt: 8, 
//             p: 4, 
//             background: 'rgba(255, 255, 255, 0.05)',
//             backdropFilter: 'blur(10px)',
//             borderRadius: '20px',
//             border: '1px solid rgba(255, 255, 255, 0.1)',
//             textAlign: 'center'
//           }}>
//             <Typography variant="h5" sx={{ 
//               fontWeight: 'bold', 
//               mb: 2,
//               background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
//               WebkitBackgroundClip: 'text',
//               WebkitTextFillColor: 'transparent'
//             }}>
//               Stay Updated
//             </Typography>
//             <Typography variant="body1" sx={{ color: '#cbd5e0', mb: 3 }}>
//               Subscribe to our newsletter for the latest updates and educational resources.
//             </Typography>
//             <Box sx={{ 
//               display: 'flex', 
//               gap: 2, 
//               justifyContent: 'center',
//               flexWrap: 'wrap',
//               alignItems: 'center'
//             }}>
//               <Chip
//                 icon={<AutoAwesome />}
//                 label="New Features Coming Soon"
//                 sx={{
//                   background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
//                   color: 'white',
//                   fontWeight: 'bold'
//                 }}
//               />
//               <Chip
//                 icon={<TrendingUp />}
//                 label="95% User Satisfaction"
//                 sx={{
//                   background: 'linear-gradient(135deg, #4ecdc4 0%, #44a08d 100%)',
//                   color: 'white',
//                   fontWeight: 'bold'
//                 }}
//               />
//             </Box>
//           </Box>
//         </motion.div>

//         {/* Footer Bottom */}
//         <FooterBottom>
//           <motion.div
//             initial={{ opacity: 0 }}
//             whileInView={{ opacity: 1 }}
//             transition={{ duration: 0.6, delay: 0.5 }}
//             viewport={{ once: true }}
//           >
//             <Typography variant="body2" sx={{ 
//               color: '#a0aec0',
//               fontSize: '0.9rem'
//             }}>
//               © 2025 SSPACE Assist. All Rights Reserved. | Privacy Policy | Terms of Service
//             </Typography>
//             <Typography variant="body2" sx={{ 
//               color: '#718096',
//               mt: 1,
//               fontSize: '0.8rem'
//             }}>
//               Made with ❤️ for students and educators worldwide
//             </Typography>
//           </motion.div>
//         </FooterBottom>
//       </Box>
//     </FooterContainer>
//   );
// };

// export default Footer;



import React, { useState } from 'react';
import { 
  Container, 
  Box, 
  Typography, 
  Grid, 
  Link, 
  IconButton, 
  useTheme,
  alpha,
  Chip,
  Tooltip,
  TextField,
  Button,
  InputAdornment,
  Divider
} from '@mui/material';
import { 
  Facebook, 
  Twitter, 
  Instagram, 
  LinkedIn,
  Email,
  Phone,
  LocationOn,
  School,
  AutoAwesome,
  TrendingUp,
  SupportAgent,
  Send,
  ArrowUpward,
  Star,
  BookmarkBorder,
  Notifications,
  Language
} from '@mui/icons-material';
import { motion, AnimatePresence } from 'framer-motion';
import { styled, keyframes } from '@mui/material/styles';

// Enhanced Animations
const float = keyframes`
  0%, 100% { transform: translateY(0px) rotate(0deg); }
  25% { transform: translateY(-3px) rotate(1deg); }
  50% { transform: translateY(-5px) rotate(0deg); }
  75% { transform: translateY(-3px) rotate(-1deg); }
`;

const shimmer = keyframes`
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
`;

const pulse = keyframes`
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.05); }
`;

const glow = keyframes`
  0%, 100% { box-shadow: 0 0 5px rgba(102, 126, 234, 0.5); }
  50% { box-shadow: 0 0 20px rgba(102, 126, 234, 0.8), 0 0 30px rgba(102, 126, 234, 0.3); }
`;

const slideIn = keyframes`
  from { transform: translateX(-100%); opacity: 0; }
  to { transform: translateX(0); opacity: 1; }
`;

// Enhanced Styled Components
const FooterContainer = styled(Box)(({ theme }) => ({
  background: `
    linear-gradient(135deg, #0f0f23 0%, #1a1a2e 25%, #16213e 50%, #0f3460 75%, #533483 100%),
    radial-gradient(circle at 20% 80%, rgba(120, 119, 198, 0.1) 0%, transparent 50%),
    radial-gradient(circle at 80% 20%, rgba(255, 119, 198, 0.1) 0%, transparent 50%)
  `,
  color: '#f8fafc',
  position: 'relative',
  overflow: 'hidden',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: '2px',
    background: 'linear-gradient(90deg, transparent, #667eea, #764ba2, #f093fb, transparent)',
    animation: `${slideIn} 2s ease-out`,
  },
  '&::after': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: `
      radial-gradient(circle at 25% 25%, rgba(102, 126, 234, 0.03) 0%, transparent 50%),
      radial-gradient(circle at 75% 75%, rgba(240, 147, 251, 0.03) 0%, transparent 50%),
      url("data:image/svg+xml,%3Csvg width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg"%3E%3Cg fill="none" fill-rule="evenodd"%3E%3Cg fill="%23ffffff" fill-opacity="0.02"%3E%3Ccircle cx="30" cy="30" r="1"/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")
    `,
    animation: `${float} 25s ease-in-out infinite`,
  }
}));

const LogoContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  textDecoration: 'none',
  transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
  cursor: 'pointer',
  '&:hover': {
    transform: 'scale(1.03) translateY(-3px)',
    filter: 'brightness(1.1)',
  }
});

const LogoImage = styled('img')({
  height: 65,
  marginRight: 18,
  transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
  filter: 'drop-shadow(0 6px 12px rgba(102, 126, 234, 0.4))',
  '&:hover': {
    transform: 'rotate(-8deg) scale(1.15)',
    filter: 'drop-shadow(0 8px 16px rgba(102, 126, 234, 0.6))',
    animation: `${glow} 2s ease-in-out infinite`,
  }
});

const LogoText = styled(Typography)({
  fontFamily: '"Inter", "Montserrat", sans-serif',
  fontWeight: 900,
  fontSize: '2rem',
  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 30%, #f093fb 60%, #ffeaa7 100%)',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  backgroundSize: '300% 300%',
  animation: `${shimmer} 4s ease-in-out infinite`,
  textTransform: 'uppercase',
  letterSpacing: '1px',
  textShadow: '0 0 30px rgba(102, 126, 234, 0.5)',
});

const SectionTitle = styled(Typography)({
  fontWeight: 800,
  fontSize: '1.3rem',
  marginBottom: 28,
  position: 'relative',
  display: 'inline-block',
  color: '#ffffff',
  '&::after': {
    content: '""',
    position: 'absolute',
    bottom: -10,
    left: 0,
    width: '60%',
    height: '4px',
    background: 'linear-gradient(90deg, #667eea 0%, #764ba2 50%, #f093fb 100%)',
    borderRadius: '3px',
    animation: `${shimmer} 3s ease-in-out infinite`,
  }
});

const FooterLink = styled(Link)(({ theme }) => ({
  color: '#e2e8f0',
  textDecoration: 'none',
  display: 'flex',
  alignItems: 'center',
  padding: '10px 0',
  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  position: 'relative',
  fontSize: '0.95rem',
  fontWeight: 500,
  '&:hover': {
    color: '#667eea',
    transform: 'translateX(12px)',
    '&::before': {
      content: '""',
      position: 'absolute',
      left: -20,
      top: '50%',
      transform: 'translateY(-50%)',
      width: 6,
      height: 6,
      borderRadius: '50%',
      background: 'linear-gradient(45deg, #667eea, #f093fb)',
      animation: `${pulse} 1.5s ease-in-out infinite`,
      boxShadow: '0 0 10px rgba(102, 126, 234, 0.8)',
    }
  }
}));

const SocialIconButton = styled(IconButton)(({ color }) => ({
  color: '#cbd5e0',
  transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
  borderRadius: '16px',
  padding: '14px',
  margin: '0 4px',
  background: 'rgba(255, 255, 255, 0.05)',
  backdropFilter: 'blur(10px)',
  border: '1px solid rgba(255, 255, 255, 0.1)',
  '&:hover': {
    color: color || '#667eea',
    backgroundColor: alpha(color || '#667eea', 0.15),
    transform: 'translateY(-5px) scale(1.15) rotate(5deg)',
    boxShadow: `0 10px 30px ${alpha(color || '#667eea', 0.4)}`,
    border: `1px solid ${alpha(color || '#667eea', 0.3)}`,
  }
}));

const ContactItem = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  marginBottom: 18,
  padding: '10px 16px',
  borderRadius: '12px',
  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  background: 'rgba(255, 255, 255, 0.03)',
  border: '1px solid rgba(255, 255, 255, 0.08)',
  '&:hover': {
    transform: 'translateX(8px)',
    background: 'rgba(102, 126, 234, 0.1)',
    border: '1px solid rgba(102, 126, 234, 0.2)',
    boxShadow: '0 4px 15px rgba(102, 126, 234, 0.2)',
  }
});

const StatsCard = styled(Box)(({ theme }) => ({
  background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%)',
  backdropFilter: 'blur(15px)',
  borderRadius: '20px',
  padding: theme.spacing(3.5),
  border: '1px solid rgba(255, 255, 255, 0.15)',
  textAlign: 'center',
  transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
  position: 'relative',
  overflow: 'hidden',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: '2px',
    background: 'linear-gradient(90deg, #667eea, #764ba2, #f093fb)',
    opacity: 0,
    transition: 'opacity 0.3s ease',
  },
  '&:hover': {
    transform: 'translateY(-8px) scale(1.02)',
    background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.15) 0%, rgba(255, 255, 255, 0.08) 100%)',
    boxShadow: '0 15px 40px rgba(0, 0, 0, 0.3), 0 0 20px rgba(102, 126, 234, 0.2)',
    border: '1px solid rgba(255, 255, 255, 0.25)',
    '&::before': {
      opacity: 1,
    }
  }
}));

const NewsletterBox = styled(Box)({
  background: `
    linear-gradient(135deg, rgba(102, 126, 234, 0.15) 0%, rgba(240, 147, 251, 0.15) 100%),
    rgba(255, 255, 255, 0.03)
  `,
  backdropFilter: 'blur(20px)',
  borderRadius: '24px',
  border: '2px solid rgba(255, 255, 255, 0.1)',
  padding: '2.5rem',
  textAlign: 'center',
  position: 'relative',
  overflow: 'hidden',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: '-100%',
    width: '100%',
    height: '100%',
    background: 'linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.1), transparent)',
    animation: `${slideIn} 3s ease-in-out infinite`,
  }
});

const StyledTextField = styled(TextField)({
  '& .MuiOutlinedInput-root': {
    backgroundColor: 'rgba(255, 255, 255, 0.08)',
    borderRadius: '12px',
    color: '#ffffff',
    '& fieldset': {
      borderColor: 'rgba(255, 255, 255, 0.2)',
    },
    '&:hover fieldset': {
      borderColor: 'rgba(102, 126, 234, 0.5)',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#667eea',
      boxShadow: '0 0 0 2px rgba(102, 126, 234, 0.2)',
    },
  },
  '& .MuiInputLabel-root': {
    color: '#cbd5e0',
  },
});

const GradientButton = styled(Button)({
  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%)',
  borderRadius: '12px',
  padding: '12px 24px',
  textTransform: 'none',
  fontWeight: 700,
  fontSize: '1rem',
  boxShadow: '0 4px 15px rgba(102, 126, 234, 0.3)',
  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  '&:hover': {
    transform: 'translateY(-2px)',
    boxShadow: '0 8px 25px rgba(102, 126, 234, 0.4)',
    background: 'linear-gradient(135deg, #7c6eea 0%, #8a4ba2 50%, #f593fb 100%)',
  }
});

const FooterBottom = styled(Box)({
  borderTop: '1px solid rgba(255, 255, 255, 0.15)',
  paddingTop: 32,
  marginTop: 48,
  textAlign: 'center',
  position: 'relative',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: -1,
    left: '50%',
    transform: 'translateX(-50%)',
    width: '120px',
    height: '4px',
    background: 'linear-gradient(90deg, #667eea 0%, #764ba2 50%, #f093fb 100%)',
    borderRadius: '3px',
    animation: `${shimmer} 3s ease-in-out infinite`,
  }
});

const ScrollToTopButton = styled(IconButton)({
  position: 'fixed',
  bottom: 30,
  right: 30,
  backgroundColor: 'rgba(102, 126, 234, 0.9)',
  color: 'white',
  width: 56,
  height: 56,
  boxShadow: '0 8px 25px rgba(102, 126, 234, 0.3)',
  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  zIndex: 1000,
  '&:hover': {
    backgroundColor: '#667eea',
    transform: 'translateY(-3px) scale(1.1)',
    boxShadow: '0 12px 35px rgba(102, 126, 234, 0.4)',
  }
});

const Footer = () => {
  const theme = useTheme();
  const [email, setEmail] = useState('');
  const [showScrollTop, setShowScrollTop] = useState(true);
  const [hoveredStat, setHoveredStat] = useState(null);

  const socialLinks = [
    { icon: <Facebook />, href: '#', color: '#1877f2', label: 'Facebook' },
    { icon: <Twitter />, href: '#', color: '#1da1f2', label: 'Twitter' },
    { icon: <Instagram />, href: '#', color: '#e4405f', label: 'Instagram' },
    { icon: <LinkedIn />, href: '#', color: '#0077b5', label: 'LinkedIn' },
  ];

  const quickLinks = [
    { label: 'Home', href: '/', icon: '🏠' },
    { label: 'About Us', href: '/about', icon: '👥' },
    { label: 'Dashboard', href: '/dashboard', icon: '📊' },
    { label: 'Contact', href: '/contact', icon: '📞' },
  ];

  const resources = [
    { label: 'Study Materials', href: '/documents', icon: '📚' },
    { label: 'Announcements', href: '/notices', icon: '📢' },
    { label: 'Academic Calendar', href: '/calendar', icon: '📅' },
    { label: 'Help & Support', href: '/help', icon: '❓' },
  ];

  const contactInfo = [
    { 
      icon: <Email sx={{ fontSize: 20 }} />, 
      text: 'support@sspaceassist.online', 
      href: 'mailto:support@sspaceassist.online',
      label: 'Email Us'
    },

    { 
      icon: <LocationOn sx={{ fontSize: 20 }} />, 
      text: 'Ramnagar Bapuji Wadi, Wardha', 
      href: 'https://share.google/nq0kSx46gNuJDHXBf',
      label: 'Visit Us'
    },
  ];

  const stats = [
    // { number: '15K+', label: 'Active Students', icon: <School />, color: '#667eea' },
    // { number: '98%', label: 'Success Rate', icon: <TrendingUp />, color: '#f093fb' },
    { number: '24/7', label: 'Support Available', icon: <SupportAgent />, color: '#4ecdc4' },
  ];

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (email) {
      console.log('Subscribing:', email);
      setEmail('');
      // Add success feedback here
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };


  return (
    <>
      <FooterContainer>
        <Box sx={{ 
          position: 'relative', 
          zIndex: 1, 
          py: 10,
          maxWidth: '1400px',
          margin: '0 auto',
          width: '100%',
          px: 3
        }}>
          {/* Main Footer Content */}
          <Grid container spacing={8}>
            {/* Enhanced Brand Section */}
            <Grid item xs={12} lg={4}>
              <motion.div
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8 }}
                viewport={{ once: true }}
              >
                <LogoContainer>
                  <LogoImage src="/exam.png" alt="SSPACE Assist Logo" />
                  <LogoText variant="h4">
                    SSPACE Assist
                  </LogoText>
                </LogoContainer>
                
                <Typography variant="body1" sx={{ 
                  color: '#e2e8f0', 
                  mb: 4, 
                  lineHeight: 1.7,
                  fontSize: '1.1rem',
                  fontWeight: 400
                }}>
                  Transforming education through innovative technology. Join thousands of students 
                  achieving academic excellence with our comprehensive learning platform.
                </Typography>

                <Box sx={{ mb: 4 }}>
                  <Typography variant="h6" sx={{ 
                    color: '#ffffff', 
                    mb: 3, 
                    fontWeight: 700,
                    fontSize: '1.1rem'
                  }}>
                    Get in Touch
                  </Typography>
                  {contactInfo.map((contact, index) => (
                    <ContactItem key={index}>
                      <Tooltip title={contact.label} arrow placement="top">
                        <Box sx={{ 
                          color: '#667eea', 
                          mr: 3, 
                          display: 'flex', 
                          alignItems: 'center',
                          minWidth: '24px'
                        }}>
                          {contact.icon}
                        </Box>
                      </Tooltip>
                      <FooterLink href={contact.href} color="inherit">
                        {contact.text}
                      </FooterLink>
                    </ContactItem>
                  ))}
                </Box>

                {/* Enhanced Social Links */}
                <Box>
                  <Typography variant="h6" sx={{ 
                    color: '#ffffff', 
                    mb: 2, 
                    fontWeight: 700,
                    fontSize: '1.1rem'
                  }}>
                    Connect With Us
                  </Typography>
                  <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mb: 2 }}>
                    {socialLinks.map((social, index) => (
                      <Tooltip key={index} title={`Follow us on ${social.label}`} arrow>
                        <SocialIconButton
                          href={social.href}
                          color={social.color}
                        >
                          {social.icon}
                        </SocialIconButton>
                      </Tooltip>
                    ))}
                  </Box>
                </Box>
              </motion.div>
            </Grid>

            {/* Quick Links Section */}
            <Grid item xs={12} sm={6} lg={2}>
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.1 }}
                viewport={{ once: true }}
              >
                <SectionTitle variant="h6">
                  Quick Links
                </SectionTitle>
                <Box component="ul" sx={{ listStyle: 'none', padding: 0, margin: 0 }}>
                  {quickLinks.map((link, index) => (
                    <Box component="li" key={index}>
                      <FooterLink href={link.href} color="inherit">
                        <Box sx={{ mr: 1.5, fontSize: '1.1rem' }}>{link.icon}</Box>
                        {link.label}
                      </FooterLink>
                    </Box>
                  ))}
                </Box>
              </motion.div>
            </Grid>

            {/* Resources Section */}
            <Grid item xs={12} sm={6} lg={2}>
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.2 }}
                viewport={{ once: true }}
              >
                <SectionTitle variant="h6">
                  Resources
                </SectionTitle>
                <Box component="ul" sx={{ listStyle: 'none', padding: 0, margin: 0 }}>
                  {resources.map((resource, index) => (
                    <Box component="li" key={index}>
                      <FooterLink href={resource.href} color="inherit">
                        <Box sx={{ mr: 1.5, fontSize: '1.1rem' }}>{resource.icon}</Box>
                        {resource.label}
                      </FooterLink>
                    </Box>
                  ))}
                </Box>
              </motion.div>
            </Grid>

            {/* Enhanced Stats Section */}
            <Grid item xs={12} lg={4}>
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.3 }}
                viewport={{ once: true }}
              >
                <SectionTitle variant="h6">
                  Our Impact
                </SectionTitle>
                <Grid container spacing={3}>
                  {stats.map((stat, index) => (
                    <Grid item xs={12} sm={4} lg={12} key={index}>
                      <StatsCard
                        onMouseEnter={() => setHoveredStat(index)}
                        onMouseLeave={() => setHoveredStat(null)}
                      >
                        <motion.div
                          animate={hoveredStat === index ? { scale: 1.1 } : { scale: 1 }}
                          transition={{ duration: 0.2 }}
                        >
                          <Box sx={{ 
                            color: stat.color, 
                            mb: 2,
                            display: 'flex',
                            justifyContent: 'center',
                            fontSize: '2rem'
                          }}>
                            {stat.icon}
                          </Box>
                        </motion.div>
                        <Typography variant="h4" sx={{ 
                          fontWeight: 900, 
                          color: '#ffffff',
                          fontSize: '2.2rem',
                          mb: 1
                        }}>
                          {stat.number}
                        </Typography>
                        <Typography variant="body2" sx={{ 
                          color: '#cbd5e0',
                          fontSize: '0.95rem',
                          fontWeight: 600
                        }}>
                          {stat.label}
                        </Typography>
                      </StatsCard>
                    </Grid>
                  ))}
                </Grid>
              </motion.div>
            </Grid>
          </Grid>

          {/* Enhanced Newsletter Section */}
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            viewport={{ once: true }}
          >
            <NewsletterBox sx={{ mt: 10 }}>
              <Typography variant="h4" sx={{ 
                fontWeight: 900, 
                mb: 3,
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                fontSize: '2.2rem'
              }}>
                Stay Ahead of the Curve
              </Typography>
              <Typography variant="body1" sx={{ 
                color: '#e2e8f0', 
                mb: 4, 
                fontSize: '1.2rem',
                fontWeight: 400,
                maxWidth: '600px',
                margin: '0 auto 2rem auto'
              }}>
                Get the latest updates, study tips, and exclusive content delivered to your inbox. 
                Join our community of learners!
              </Typography>
              
              <Box 
                component="form" 
                onSubmit={handleSubscribe}
                sx={{ 
                  display: 'flex', 
                  gap: 2, 
                  justifyContent: 'center',
                  flexWrap: 'wrap',
                  alignItems: 'center',
                  mb: 4,
                  maxWidth: '500px',
                  margin: '0 auto 2rem auto'
                }}
              >
                <StyledTextField
                  variant="outlined"
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  type="email"
                  required
                  sx={{ flexGrow: 1, minWidth: '250px' }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <Email sx={{ color: '#667eea' }} />
                      </InputAdornment>
                    ),
                  }}
                />
                <GradientButton
                  type="submit"
                  variant="contained"
                  endIcon={<Send />}
                  sx={{ minWidth: '140px' }}
                >
                  Subscribe
                </GradientButton>
              </Box>

              <Box sx={{ 
                display: 'flex', 
                gap: 2, 
                justifyContent: 'center',
                flexWrap: 'wrap',
                alignItems: 'center'
              }}>
                <Chip
                  icon={<Star />}
                  label="Premium Content"
                  sx={{
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    color: 'white',
                    fontWeight: 'bold',
                    fontSize: '0.9rem',
                    height: '36px'
                  }}
                />
                <Chip
                  icon={<BookmarkBorder />}
                  label="Study Resources"
                  sx={{
                    background: 'linear-gradient(135deg, #4ecdc4 0%, #44a08d 100%)',
                    color: 'white',
                    fontWeight: 'bold',
                    fontSize: '0.9rem',
                    height: '36px'
                  }}
                />
                <Chip
                  icon={<Notifications />}
                  label="Instant Updates"
                  sx={{
                    background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
                    color: 'white',
                    fontWeight: 'bold',
                    fontSize: '0.9rem',
                    height: '36px'
                  }}
                />
              </Box>
            </NewsletterBox>
          </motion.div>

          {/* Enhanced Footer Bottom */}
          <FooterBottom>
            <motion.div
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ duration: 0.6, delay: 0.5 }}
              viewport={{ once: true }}
            >
              <Grid container spacing={2} alignItems="center" justifyContent="center">
                <Grid item xs={12} sm={6} sx={{ textAlign: { xs: 'center', sm: 'left' } }}>
                  <Typography variant="body2" sx={{ 
                    color: '#a0aec0',
                    fontSize: '0.95rem',
                    fontWeight: 500
                  }}>
                    © {new Date().getFullYear()} Sspace Assist. All Rights Reserved.
                  </Typography>
                  <Box sx={{ display: 'flex', gap: 2, mt: 1, justifyContent: { xs: 'center', sm: 'flex-start' } }}>
                    <Link href="#" sx={{ color: '#718096', fontSize: '0.85rem', '&:hover': { color: '#667eea' } }}>
                      Privacy Policy
                    </Link>
                    <Box sx={{ color: '#718096' }}>•</Box>
                    <Link href="#" sx={{ color: '#718096', fontSize: '0.85rem', '&:hover': { color: '#667eea' } }}>
                      Terms of Service
                    </Link>
                    <Box sx={{ color: '#718096' }}>•</Box>
                    <Link href="#" sx={{ color: '#718096', fontSize: '0.85rem', '&:hover': { color: '#667eea' } }}>
                      Cookies
                    </Link>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6} sx={{ textAlign: { xs: 'center', sm: 'right' } }}>
                  <Typography variant="body2" sx={{ 
                    color: '#718096',
                    fontSize: '0.9rem',
                    fontWeight: 400,
                    mb: 1
                  }}>
                    Made with ❤️ for students 
                  </Typography>
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: { xs: 'center', sm: 'flex-end' }, gap: 1 }}>
                    <Language sx={{ fontSize: 16, color: '#667eea' }} />
                    <Typography variant="body2" sx={{ color: '#718096', fontSize: '0.85rem' }}>
                    </Typography>
                  </Box>
                </Grid>
              </Grid>

              <Divider sx={{ 
                my: 3, 
                borderColor: 'rgba(255, 255, 255, 0.1)',
                '&::before, &::after': {
                  borderColor: 'rgba(255, 255, 255, 0.1)',
                }
              }} />
              
              <Box sx={{ textAlign: 'center' }}>
                <Typography variant="body2" sx={{ 
                  color: '#64748b',
                  fontSize: '0.8rem',
                  fontStyle: 'italic'
                }}>
                  "Education is the most powerful weapon which you can use to change the world." - Nelson Mandela
                </Typography>
              </Box>
            </motion.div>
          </FooterBottom>
        </Box>
      </FooterContainer>

      {/* Scroll to Top Button */}
      <AnimatePresence>
        {showScrollTop && (
          <motion.div
            initial={{ opacity: 0, scale: 0 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0 }}
            transition={{ duration: 0.3 }}
          >
            <ScrollToTopButton onClick={scrollToTop}>
              <ArrowUpward />
            </ScrollToTopButton>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default Footer;